import React, {useEffect, useState} from "react";
import {
    ButtonPrimary,
    ButtonSecondary,
    Dropdown,
    Heading,
    IconArrowLeft20,
    IconArrowRight20,
    IconSearch24,
    Input,
    ProgressIndicatorCircular,
    ToggleSwitch
} from "pac-ux-components";
import EditTenantModal from "./EditTenantModal";
import Add24 from "pac-ux-components/build/Icons/Navigation/Add24";
import AddTenantModal from "./AddTenantModal";
import useTenants from "../../hooks/useTenants";
import Loading from "../Loading";
import {useCookies} from "react-cookie";

function TenantList() {
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [editingTenant, setEditingTenant] = useState(null);
    const [addingTenant, setAddingTenant] = useState(false);
    const tenantsPerPage = 12;
    const {tenants, setTenants, getTenants, loading, setLoading, error, setError} = useTenants();
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }


    async function handleSave(tenant, method = 'PUT') {
        try {
            let url = apiRoot + '/backoffice/tenants';
                if (method === 'PUT') {
                url += '/' + tenant.id;
            }
            const response = await fetch(url, {
                method: method, headers: apiHeaders, body: JSON.stringify(tenant),
            });

            if (!response.ok) {
                throw new Error('Failed to save tenant');
            }
        } catch (error) {
            console.error('Error saving tenant:', error);
            setError('Failed to save tenant.');
        } finally {
            setEditingTenant(null);
            setAddingTenant(false);
            setLoading(true);
            getTenants().then(() => setLoading(false));
        }
    }

    const handleEnableTenant = async (tenant) => {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenant.id, {headers:apiHeaders})
        let updatedTenant = await response.json();
        updatedTenant.enabled = true;
        if(updatedTenant.signatureSecret === '') {
            setError('Signature Secret is empty, please edit and add a secret signature before enabling');
            return;
        }

        try {
            const response = await fetch(apiRoot + '/backoffice/tenants/' + tenant.id, {
                method: 'PUT', headers: apiHeaders, body: JSON.stringify(updatedTenant),
            });

            if (!response.ok) {
                throw new Error('Failed to enable tenant');
            }

            setTenants((prevTenants) => prevTenants.map((t) => t.id === tenant.id ? {...t, enabled: true} : t));
        } catch (error) {
            console.error('Error enabling tenant:', error);
            setError('Failed to enable tenant.');
        }
    }

    const handleDisableTenant = async (tenantId) => {
        try {
            const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId, {
                method: 'DELETE',
                headers: apiHeaders,
            });

            if (!response.ok) {
                throw new Error('Failed to disable tenant');
            }

            setTenants((prevTenants) => prevTenants.map((tenant) => tenant.id === tenantId ? {
                ...tenant, enabled: false
            } : tenant));
        } catch (error) {
            console.error('Error disabling tenant:', error);
            setError('Failed to disable tenant.');
        }
    };

    if (loading) return (<Loading/>);

    if (error) return <p>Error: {error}</p>;

    function handleClickPageLeft() {
        if (currentPage === 1 || filteredTenants.length === 0) {
            return;
        }
        setCurrentPage(currentPage - 1);
    }

    function handleClickPageRight() {
        if (currentPage === totalPages || filteredTenants.length === 0) {
            return;
        }
        setCurrentPage(currentPage + 1);
    }

    function handleSearchTenant(event) {
        setSearch(event.target.value.toLowerCase());
        setCurrentPage(1);
    }

    function clearSearchTenant() {
        if (search !== '') {
            setSearch('');
            setCurrentPage(1);
        }
    }

    const filteredTenants = tenants.filter(tenant => tenant.name.toLowerCase().includes(search));
    const totalPages = Math.ceil(filteredTenants.length / tenantsPerPage);
    const currentTenants = filteredTenants.slice((currentPage - 1) * tenantsPerPage, currentPage * tenantsPerPage);

    const handlePageChange = (newPage) => {
        setCurrentPage(Number(newPage));
    };

    function handleClickTenant(tenant) {
        setEditingTenant(tenant);
    }

    return (<div className="Tenants" style={{width: 1047}}>

        <Heading color={'#10304C'} style={{paddingTop: 56, paddingBottom: 16}}

        >Tenants</Heading>

        <Input
            style={{
                marginBottom: 32, width: 523, height: 40,
            }}
            value={search}
            onChange={handleSearchTenant}
            placeholder="Search for Tenant"
            icon={<IconSearch24 style={{marginTop: -36, color: 'black'}}/>}
        />


        <div style={{float: 'right', marginTop: '-50px'}}>
            <div style={{textAlign: 'center', paddingBottom: '30px'}}><a href="/logs?table=tenants"><img src="/image/history_icon.svg" width={24} height={23} alt={History}/></a></div>
            <ButtonPrimary
                onClick={() => {
                    setAddingTenant(true)
                }}
            ><Add24/> Add Tenant </ButtonPrimary>
        </div>

        <ButtonSecondary
            style={{cursor: 'pointer', marginLeft: 24}}
            onClick={clearSearchTenant}
            disabled={(search == '')}
        >
            Clear
        </ButtonSecondary>
        <table width="1047px" className="Table" style={{}}>
            <thead>
            <tr style={{fontWeight: 600, height: 48, fontSize: 16, fontFamily: 'Inter', border: "thin solid #E0E0E0"}}>
                <td width="400" style={{paddingLeft: 32}}>Tenant</td>
                <td width="200">Airline ICAO</td>
                <td width="300"></td>
                <td>Enable</td>
            </tr>
            </thead>
            <tbody>
            {currentTenants.map((tenant, index) => (<tr key={tenant.id} style={{
                height: 48,
                fontSize: 16,
                fontWeight: 400,
                backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                border: "thin solid #E0E0E0"
            }}>
                <td style={{paddingLeft: 32}}>
                    <span onClick={() => handleClickTenant(tenant)} style={{cursor: 'pointer'}}>{tenant.name}</span>
                </td>
                <td>
                    {tenant.airlineIcao || 'N/A'}
                </td>
                <td></td>
                <td align="right">
                    <ToggleSwitch
                        checked={tenant.enabled}
                        onClick={() => tenant.enabled ? handleDisableTenant(tenant.id) : handleEnableTenant(tenant)}
                    >
                        {tenant.enabled ? 'On' : 'Off'}
                    </ToggleSwitch>
                </td>
            </tr>))}
            </tbody>
        </table>
        <div style={{marginTop: 10, width: 1047}}>
        <span>
          {currentTenants.length > 0 ? `${(currentPage - 1) * tenantsPerPage + 1} - ${Math.min(currentPage * tenantsPerPage, filteredTenants.length)} of ${filteredTenants.length}` : '0 results'}
        </span>
            <span style={{float: 'right'}}>
          Page{' '}

                <Dropdown
                    options={Array.from({length: totalPages}).map((_, index) => ({
                            value: index + 1, disabled: false, label: index + 1
                        })
                    )}
                    disabled={filteredTenants.length === 0}
                    selected={currentPage}
                    style={{width: 62, marginRight: 4}}
                    onChange={handlePageChange}
                />
                of {totalPages}

                <span style={{marginLeft: 32}}>
                    <IconArrowLeft20
                        style={{
                            margin: 8,
                            cursor: (currentPage === 1) ? 'auto' : 'pointer',
                        }}
                        color={currentPage === 1 ? '#ADADAD' : '#000000'}
                        onClick={handleClickPageLeft}
                    />
                    <IconArrowRight20
                        style={{
                            margin: 8,
                            cursor: (currentPage === totalPages || filteredTenants.length === 0) ? 'auto' : 'pointer',
                        }}
                        color={(currentPage === totalPages || filteredTenants.length === 0) ? '#ADADAD' : '#000000'}
                        onClick={handleClickPageRight}
                    />
                </span>
        </span>

        </div>
        {editingTenant !== null && (
            <EditTenantModal
                tenant={editingTenant}
                display={editingTenant === null ? false : true}
                handleSave={handleSave}
                closeModal={() => setEditingTenant(null)}/>
        )}

        {addingTenant === true && (
            <AddTenantModal
                display={true}
                handleSave={handleSave}
                closeModal={() => setAddingTenant(false)}/>
        )}

    </div>);
}

export default TenantList;